<template>
  <div>
    <div
      v-for="(image, index) in images"
      :key="image.url"
      v-lazy:background-image="image.url"
      class="absolute top-0 left-0 right-0 bottom-0 bg-cover bg-center transition-all duration-[3000ms]"
      :class="{
        'opacity-0': counter !== index,
        'opacity-100': counter === index
      }"
    />
    <div v-if="controls != 'none' && images.length > 1" class="flex absolute z-50 w-full h-full justify-between items-center text-primary p-1" >
      <button class="p-2 rounded-full hover:shadow-lg bg-white hover:bg-primary hover:text-white" :class="{ '-translate-x-10 md:-translate-x-24': controls == 'outside' }" @click="goBack" >
        <svg-vue icon="nav-arrow" role="link" aria-label="press enter to go back a slide" class="-rotate-90 fill-current h-4 w-4 -translate-x-[2px]" ></svg-vue>
      </button>
      <button class="p-2 rounded-full hover:shadow-lg bg-white hover:bg-primary hover:text-white" :class="{ 'translate-x-10 md:translate-x-24': controls == 'outside' }" @click="goNext" >
        <svg-vue icon="nav-arrow" role="link" aria-label="press enter to advance a slide" class="rotate-90 fill-current h-4 w-4 translate-x-[2px]" ></svg-vue>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Slider',

  props: {
    images: {
      type: Array,
      default: () => []
    },
    controls: {
      type: String,
      default: 'none'
    },
    contain: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      counter: 0,
      paused: false
    }
  },

  mounted () {
    setInterval(() => { if(this.paused === false){ this.next() } }, 6000);
  },

  methods: {
    next () {
      if(this.counter === this.images.length-1){
        this.counter = -1
      }

      this.counter++
    },
    prev () {
      this.counter--

      if(this.counter === -1){
        this.counter = this.images.length-1
      }
    },

    goBack () {
      this.pause = true
      clearInterval(this.running)
      this.prev()
    },
    goNext () {
      this.pause = true
      clearInterval(this.running)
      this.next()
    }
  }
}
</script>
